// extracted by mini-css-extract-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary_CheckoutSummary__2P0SR","Burger":"CheckoutSummary_Burger__1KK8C"};